import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }

import { useRouter } from "vue-router";
//import Lucide from "../../base-components/Lucide";
import SideMenuTooltip from "./SideMenuTooltip.vue";
import { FormattedMenu, linkTo } from "./main-menu";
import {checkTypeOfIcon, substractNameOfIcon} from "@wpmss/ts-icons-helper"

interface MenuProps {
  class?: string | object;
  menu: FormattedMenu;
  layout: "rubick" | "enigma" | "icewall" | "tinker";
  isRoot: boolean;
  position: "side" | "simple";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SideMenuLink',
  props: {
    class: null,
    menu: null,
    layout: null,
    isRoot: { type: Boolean },
    position: null
  },
  setup(__props: any) {

const props = __props as {
  class?: string | object;
  menu: FormattedMenu;
  layout: "rubick" | "enigma" | "icewall" | "tinker";
  isRoot: boolean;
  position: "side" | "simple";
}

const router = useRouter();
// @ts-ignore


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Lucide = _resolveComponent("Lucide")!

  return (_openBlock(), _createBlock(SideMenuTooltip, {
    key: props.menu.title,
    as: "a",
    content: _ctx.$t(props.menu.title),
    position: __props.position,
    href: 
      props.menu.subMenu && props.menu.subMenu.length > 0
        ? 'javascript:;'
        : 'management/' + props.menu.href
    ,
    class: _normalizeClass([
      {
        'h-[50px] flex items-center pl-5 text-white mb-1 relative rounded-full':
          __props.layout === 'rubick',
        'dark:text-slate-300':
          props.menu.active && !__props.isRoot && __props.layout === 'rubick',
        'text-white/70 dark:text-slate-400':
          !props.menu.active && !__props.isRoot && __props.layout === 'rubick',
        'z-10 bg-slate-100 dark:bg-darkmode-700':
          props.menu.active && __props.isRoot && __props.layout === 'rubick',
        'before:content-[\'\'] before:w-[30px] before:h-[30px] before:-mt-[30px] before:rotate-90 before:scale-[1.04] before:bg-[length:100%] before:bg-menu-corner before:absolute before:top-0 before:right-0 before:-mr-5 dark:before:bg-menu-corner-dark':
          props.menu.active && __props.isRoot && __props.layout === 'rubick',
        'after:content-[\'\'] after:w-[30px] after:h-[30px] after:mt-[50px] after:scale-[1.04] after:bg-[length:100%] after:bg-menu-corner after:absolute after:top-0 after:right-0 after:-mr-5 dark:after:bg-menu-corner-dark':
          props.menu.active && __props.isRoot && __props.layout === 'rubick',
        '[&>div:nth-child(1)]:hover:before:bg-white/5 [&>div:nth-child(1)]:hover:before:dark:bg-darkmode-500/70':
          !props.menu.active &&
          !props.menu.activeDropdown &&
          __props.isRoot &&
          __props.layout === 'rubick',
      },
      {
        'h-[50px] flex items-center pl-5 text-slate-600 mb-1 relative rounded-xl dark:text-slate-300':
          __props.layout === 'enigma',
        'text-slate-600 dark:text-slate-400':
          !props.menu.active && props.level != 'first' && __props.layout === 'enigma',
        'bg-slate-100 dark:bg-transparent':
          props.menu.active && __props.isRoot && __props.layout === 'enigma',
        'before:content-[\'\'] before:block before:inset-0 before:rounded-xl before:absolute before:border-b-[3px] before:border-solid before:border-black/[0.08] before:dark:border-black/[0.08]':
          props.menu.active && __props.isRoot && __props.layout === 'enigma',
        'after:content-[\'\'] after:w-[20px] after:h-[80px] after:mr-[-27px] after:bg-menu-active after:bg-no-repeat after:bg-cover after:absolute after:top-0 after:bottom-0 after:right-0 after:my-auto after:dark:bg-menu-active-dark':
          props.menu.active && __props.isRoot && __props.layout === 'enigma',
        'hover:bg-slate-100 hover:dark:bg-transparent hover:before:content-[\'\'] hover:before:block hover:before:inset-0 hover:before:rounded-xl hover:before:absolute hover:before:z-[-1] hover:before:border-b-[3px] hover:before:border-solid hover:before:border-black/[0.08] hover:before:dark:bg-darkmode-700':
          !props.menu.active &&
          !props.menu.activeDropdown &&
          __props.isRoot &&
          __props.layout === 'enigma',
        // Animation
        'after:-mr-[47px] after:opacity-0 after:animate-[0.4s_ease-in-out_0.1s_active-side-menu-chevron] after:animate-fill-mode-forwards':
          props.menu.active && __props.isRoot && __props.layout === 'enigma',
      },
      {
        'h-[50px] flex items-center pl-5 text-white mb-1 relative rounded-lg':
          __props.layout === 'icewall',
        'dark:text-slate-300':
          props.menu.active && !__props.isRoot && __props.layout === 'icewall',
        'text-white/70 dark:text-slate-400':
          !props.menu.active && !__props.isRoot && __props.layout === 'icewall',
        'bg-primary dark:bg-transparent':
          props.menu.active && __props.isRoot && __props.layout === 'icewall',
        'before:content-[\'\'] before:block before:inset-0 before:bg-white/[0.08] before:rounded-lg before:absolute before:border-b-[3px] before:border-solid before:border-black/10 before:dark:border-black/10':
          props.menu.active && __props.isRoot && __props.layout === 'icewall',
        'after:content-[\'\'] after:w-[20px] after:h-[80px] after:mr-[-27px] after:bg-no-repeat after:bg-cover after:absolute after:top-0 after:bottom-0 after:right-0 after:my-auto after:bg-menu-active dark:after:bg-menu-active-dark':
          props.menu.active && __props.isRoot && __props.layout === 'icewall',
        'hover:bg-primary/60 hover:dark:bg-transparent hover:before:block hover:before:inset-0 hover:before:bg-white/[0.04] hover:before:rounded-lg hover:before:absolute hover:before:z-[-1] hover:before:dark:bg-darkmode-700':
          !props.menu.active &&
          !props.menu.activeDropdown &&
          __props.isRoot &&
          __props.layout === 'icewall',
        // Animation
        'after:mr-[-47px] after:opacity-0 after:animate-[0.3s_ease-in-out_1s_active-side-menu-chevron] after:animate-fill-mode-forwards':
          props.menu.active && __props.isRoot && __props.layout === 'icewall',
      },
      {
        'h-[50px] flex items-center pl-5 text-white mb-1 relative rounded-xl':
          __props.layout === 'tinker',
        'dark:text-slate-300':
          props.menu.active && !__props.isRoot && __props.layout === 'tinker',
        'text-white/70 dark:text-slate-400':
          !props.menu.active && !__props.isRoot && __props.layout === 'tinker',
        'bg-primary dark:bg-transparent':
          props.menu.active && __props.isRoot && __props.layout === 'tinker',
        'before:content-[\'\'] before:block before:inset-0 before:bg-white/[0.08] before:rounded-xl before:absolute before:border-b-[3px] before:border-solid before:border-black/10 before:dark:border-black/10 before:dark:bg-darkmode-700':
          props.menu.active && __props.isRoot && __props.layout === 'tinker',
        'hover:bg-primary/60 hover:dark:bg-transparent hover:before:block hover:before:inset-0 hover:before:bg-white/[0.04] hover:before:rounded-xl hover:before:absolute hover:before:z-[-1] hover:before:dark:bg-darkmode-700':
          !props.menu.active &&
          !props.menu.activeDropdown &&
          __props.isRoot &&
          __props.layout === 'tinker',
      },
      props.class,
    ]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(linkTo)(props.menu, _unref(router), $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass([
        {
          'text-primary dark:text-slate-300':
            props.menu.active && __props.isRoot && __props.layout === 'rubick',
          'dark:text-slate-400':
            !props.menu.active && __props.isRoot && __props.layout === 'rubick',
          'before:content-[\'\'] before:z-[-1] before:absolute before:top-0 before:right-0 before:-mr-5 before:w-11 before:h-full before:bg-slate-100 before:dark:bg-darkmode-700':
            props.menu.active && __props.isRoot && __props.layout === 'rubick',
          'before:content-[\'\'] before:z-[-1] before:w-[230px] before:absolute before:top-0 before:left-0 before:h-full before:rounded-l-full before:transition before:ease-in before:duration-100':
            !props.menu.activeDropdown &&
            !props.menu.active &&
            __props.isRoot &&
            __props.layout === 'rubick',
        },
        {
          'text-primary z-10 dark:text-slate-300':
            props.menu.active && __props.isRoot && __props.layout === 'enigma',
          'text-slate-700': props.menu.active && !__props.isRoot && __props.layout === 'enigma',
        },
        {
          'z-10 dark:text-slate-300':
            props.menu.active && __props.isRoot && __props.layout === 'icewall',
          'dark:text-slate-400':
            !props.menu.active && __props.isRoot && __props.layout === 'icewall',
        },
        {
          'z-10 dark:text-slate-300':
            props.menu.active && __props.isRoot && __props.layout === 'tinker',
          'dark:text-slate-400':
            !props.menu.active && __props.isRoot && __props.layout === 'tinker',
        },
      ])
      }, [
        (props.menu.menu_icon != 'no icon')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_unref(checkTypeOfIcon)(props.menu.rec_menu_icon_parent) == 'FontAwesome')
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    class: "h-7",
                    icon: _unref(substractNameOfIcon)(props.menu.menu_icon)
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true),
              (_unref(checkTypeOfIcon)(props.menu.rec_menu_icon_parent) == 'Lucide')
                ? (_openBlock(), _createBlock(_component_Lucide, {
                    key: 1,
                    icon: props.menu.menu_icon,
                    class: ""
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true),
              (_unref(checkTypeOfIcon)(props.menu.rec_menu_icon_parent) == 'HeroIcon')
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(props.menu.menu_icon), {
                    key: 2,
                    class: "w-9"
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (__props.position === 'side')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([
        {
          'hidden xl:flex items-center w-full ml-3': __props.layout === 'rubick',
          'font-medium':
            props.menu.active && props.level != 'first' && __props.layout === 'rubick',
          'text-slate-800 font-medium dark:text-slate-300':
            props.menu.active && __props.isRoot && __props.layout === 'rubick',
          'dark:text-slate-400':
            !props.menu.active && __props.isRoot && __props.layout === 'rubick',
        },
        {
          'w-full ml-3 hidden xl:flex items-center': __props.layout === 'enigma',
          'text-primary font-medium z-10 dark:text-slate-300':
            props.menu.active && __props.isRoot && __props.layout === 'enigma',
          'text-slate-700 font-medium dark:text-slate-300':
            props.menu.active && !__props.isRoot && __props.layout === 'enigma',
          'dark:text-slate-400': !props.menu.active && __props.layout === 'enigma',
        },
        {
          'hidden xl:flex items-center w-full ml-3': __props.layout === 'icewall',
          'font-medium':
            props.menu.active && props.level != 'first' && __props.layout === 'icewall',
          'font-medium z-10 dark:text-slate-300':
            props.menu.active && props.level == 'first' && __props.layout === 'icewall',
          'dark:text-slate-400':
            !props.menu.active &&
            props.level == 'first' &&
            __props.layout === 'icewall',
        },
        {
          'hidden xl:flex w-full ml-3 items-center': __props.layout === 'tinker',
          'font-medium': props.menu.active && !__props.isRoot && __props.layout === 'tinker',

          'font-medium z-10 dark:text-slate-300':
            props.menu.active && __props.isRoot && __props.layout === 'tinker',

          'dark:text-slate-400':
            !props.menu.active && __props.isRoot && __props.layout === 'tinker',
        },
      ])
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t(props.menu.title)) + " ", 1),
            (props.menu.subMenu && props.menu.subMenu.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([
          'transition ease-in duration-100 ml-auto mr-6 hidden xl:block',
          { 'transform rotate-180': props.menu.activeDropdown },
        ])
                }, [
                  _createVNode(_component_Lucide, {
                    class: "w-4 h-4",
                    icon: "ChevronDown"
                  })
                ], 2))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["content", "position", "href", "class"]))
}
}

})